import profileImg from '../assets/png/alkaria.jpg';

export const headerData = {
    name: 'Alkaria Mandal',
    title: 'Full Stack Developer',
    description: 'Full Stack Developer with 9+ years building scalable systems and modern web platforms.',
    image: profileImg,
    resumePdf: 'https://drive.google.com/file/d/1EzKkXfJPeeVkqj5e4fDz1YFMezb3cp2Z/view?usp=sharing',
    location: 'Kolkata, India',
    highlights: ['Java', 'Spring Boot', 'Angular', 'Microservices', 'Azure', 'AWS']
}
